var map = {
	"./new_s_variant_1.json": [
		38385,
		8385
	],
	"./new_s_variant_2.json": [
		52667,
		2667
	],
	"./new_s_variant_eur_1.json": [
		79232,
		9232
	],
	"./new_s_variant_eur_2.json": [
		51883,
		1883
	],
	"./new_s_variant_gbp_1.json": [
		47731,
		7731
	],
	"./new_s_variant_gbp_2.json": [
		46459,
		6459
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 44789;
module.exports = webpackAsyncContext;